<template>
  <div class="editPreInfo">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">返回上一级</el-button>
      </div>
      <el-form v-if="Object.keys(ruleForm).length>0" :model="ruleForm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws13" :label-suffix="require('@/config/enum').c_colon">

        <el-form-item label="设备编号" prop="DeviceCode">
          <el-input disabled v-model="ruleForm.MsgHead.DeviceCode" class="item-input"></el-input>
        </el-form-item>
        <el-form-item label="控制电梯门开使能" prop="MsgBody.BanLift">
          <el-select v-model="ruleForm.MsgBody.BanLift">
            <el-option label="无效" :value='0'></el-option>
            <el-option label="有效" :value='1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="声音报警使能" prop="MsgBody.EnableAlarm">
          <el-select v-model="ruleForm.MsgBody.EnableAlarm">
            <el-option label="无效" :value='0'></el-option>
            <el-option label="有效" :value='1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="灯闪烁报警使能" prop="MsgBody.AlarmLedFlash">
          <el-select v-model="ruleForm.MsgBody.AlarmLedFlash">
            <el-option label="无效" :value='0'></el-option>
            <el-option label="有效" :value='1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="梯控使能时间段" prop="MsgBody.EnablePeriod">
          <el-time-picker is-range v-model="ruleForm.MsgBody.enablePeriod" @change="selectTime($event)"
            value-format="HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
            placeholder="选择时间范围">
          </el-time-picker>
          <div>
            <el-tag v-for="(item,index) in selectTimeArr" :key="index" @click="delTime(index)" style="margin: 0 10px;">
              {{ item }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="梯控使能楼层" prop="MsgBody.EnableFloor">
          <el-input v-model="ruleForm.MsgBody.EnableFloor" class="item-input"
            placeholder="请输入梯控使能楼层（使用英文的','分隔，例：1,2,3,4,5）"></el-input>
          <el-tooltip style="margin-left: 10px;" effect="light" placement="top">
            <div slot="content">
              <span style="font-size:14px">梯控使能楼层（使用英文的','分隔，例：1,2,3,4,5）</span>
            </div>
            <i class="el-icon-warning xjbzTips"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="使能车型" prop="MsgBody.EnableModel">
          <el-select v-model="ruleForm.MsgBody.EnableModel">
            <el-option label="不检测" :value='0x0000'></el-option>
            <el-option label="电瓶车检测" :value='0x0001'></el-option>
            <el-option label="自行车检测" :value='0x0002'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="梯阻最长时间（s）" prop="MsgBody.BlockDoorTime">
          <el-input v-model.number="ruleForm.MsgBody.BlockDoorTime" class="item-input"></el-input>
          <el-tooltip style="margin-left: 10px;" effect="light" placement="top">
            <div slot="content">
              <span style="font-size:14px">单位秒, 0表示一直梯阻直到电车消失, 默认3分钟，最长6小时</span>
            </div>
            <i class="el-icon-warning xjbzTips"></i>
          </el-tooltip>
        </el-form-item>
        <el-button class="detailbtn" type="primary" @click="save()">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        enablePeriod: [],
        selectTimeArr: [],
        isDisabled: false,
        parentData: {},
        regcode: '',
        ruleForm: {},
        rules: {
          'MsgBody.BanLift': [{
            required: true,
            message: '请选择控制电梯门开使能',
            trigger: 'change'
          }],
          'MsgBody.EnableAlarm': [{
            required: true,
            message: '请选择声音报警使能',
            trigger: 'change'
          }],
          'MsgBody.AlarmLedFlash': [{
            required: true,
            message: '请选择灯闪烁报警使能',
            trigger: 'change'
          }],
          'MsgBody.EnablePeriod': [{
            required: true,
            message: '请选择梯控使能时间段',
            trigger: 'change'
          }],
          'MsgBody.EnableFloor': [{
            required: true,
            message: '请输入梯控使能楼层',
            trigger: 'blur'
          }],
          'MsgBody.EnableModel': [{
            required: true,
            message: '请选择使能车型',
            trigger: 'change'
          }],
          'MsgBody.BlockDoorTime': [{
            required: true,
            message: '请输入小于6小时的秒数值',
            trigger: 'blur'
          }, {
            validator: (rule, value, callback) => {
              if (/^(?:[0-9]|1[0-9]{1,4}|20[0-9]{3}|21[0-5][0-9]|21600)$/.test(value) == false) {
                callback(new Error('请输入小于6小时的秒数值'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          }],
        },
      }
    },
    created() {
      this.parentData = this.$route.query.object
      this.regcode = this.$route.query.object.Registercode
      this.getcableCarRead()
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // form数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule == this.saveData) {
            // 没变
            // this.isDisabled = true
          } else {
            // 变了
            // this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
      // 返回
      back() {
        console.log(this.parentData)
        this.$router.push({
          name: 'elevatorDetail',
          query: {
            object: this.parentData
          }
        })
      },
      // 选择时间段
      selectTime(e) {
        console.log(e)
        if (e && e.length > 0 && e[0] != '' && e[1] != '') {
          if (e[0] != e[1]) {
            this.selectTimeArr.push(e)
          } else {
            this.$message.error('起止时间不能相同')
          }
        }
        console.log(this.selectTimeArr)
      },
      // 删除时间段
      delTime(index) {
        this.selectTimeArr.splice(index, 1)
      },
      // 时间格式转化
      timeFormat(str) {
        let hours = str.substring(0, 2)
        let minutes = str.substring(2, 4)
        let seconds = str.substring(4, 6)
        return `${hours}:${minutes}:${seconds}`
      },
      // 获取设备参数
      getcableCarRead() {
        let loading = this.$loading()
        this.$postJson(`aapi/getMotorPetalList`, {
          'token': 'zlj365',
          'regcode': this.regcode
        }).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              if (res.liftInfo) {
                this.ruleForm = res.liftInfo
                this.ruleForm.MsgBody.EnableFloor = this.ruleForm.MsgBody.EnableFloor.join(',')
                this.selectTimeArr = this.ruleForm.MsgBody.EnablePeriod
                console.log(this.selectTimeArr)
                for (let i = 0; i < this.selectTimeArr.length; i++) {
                  for (let j = 0; j < this.selectTimeArr[i].length; j++) {
                    let formattedTime = this.timeFormat(this.selectTimeArr[i][j])
                    this.selectTimeArr[i][j] = formattedTime
                  }
                }
                // this.saveData = JSON.stringify(res.liftInfo)
                // this.isDisabled = true
              } else {
                this.$message.error('获取设备信息失败')
                // this.isDisabled = true
                this.back()
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      save() {
        var arr = this.selectTimeArr.map(innerArray => innerArray.map(item => item.replace(/:/g, '')))
        console.log(arr)
        if (arr.length == 0) {
          this.$message.error('请选择梯控使能时间段')
        } else {
          this.$refs['ruleForm'].validate(valid => {
            if (valid) {
              let loading = this.$loading()
              this.$postJson(`aapi/setMotorPetalParam`, {
                'token': 'zlj365',
                'regcode': this.regcode,
                'DeviceCode': this.ruleForm.MsgHead.DeviceCode,
                'BanLift': this.ruleForm.MsgBody.BanLift - 0,
                'EnableAlarm': this.ruleForm.MsgBody.EnableAlarm - 0,
                'AlarmLedFlash': this.ruleForm.MsgBody.AlarmLedFlash - 0,
                'EnableFloor': this.ruleForm.MsgBody.EnableFloor,
                'EnableModel': this.ruleForm.MsgBody.EnableModel - 0,
                'BlockDoorTime': this.ruleForm.MsgBody.BlockDoorTime - 0,
                EnablePeriod: arr
              }).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success('保存成功')
                    this.back()
                  } else {
                    this.$message.error(res.errMsg)
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                })
            }
          })
        }
      },
    }
  }
</script>

<style lang="scss">
  .editPreInfo {
    .item-input {
      width: 30%;
    }
  }
</style>